export async function uploadFileToS3(file: File, uploadUrl: string) {
  try {
    await fetch(uploadUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error uploading file:", error)
    throw error
  }
}
